<template>
  <button v-tooltip.top="`Insert Image`"
    class="border rounded px-2 py-1 flex items-center h-8 cursor-pointer hover:bg-gray-100 bg-white"
    @click="imageWidgetRef.showDialog()">
    <Icon name="material-symbols:add-photo-alternate-outline" class="h-[20px] w-[20px]" />
  </button>

  <WidgetsImage ref="imageWidgetRef" :business-id="props.businessId" @submit="handleSubmit" />
</template>

<script lang="ts" setup>
import WidgetsImage from '~/components/Widgets/Image.vue'
const props = defineProps(['businessId'])
const editor = defineModel('editor')
const imageWidgetRef = ref()
const showImageUploader = ref(false)
const file = ref()

const handleSubmit = (fileData) => {
  file.value = fileData.publicUrl
}

watch(file, async (newFile, oldFile) => {
  if (newFile) {
    editor.value.chain().focus().setImage({ src: newFile }).run()
    showImageUploader.value = false
    file.value = null
  }
})
</script>
